module.exports = __webpack_public_path__ + "img/planeas-1-02.c6fb9ab1.png";